import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Grid, Header, Icon, Segment } from 'semantic-ui-react';

export default function AccessDenied() {
    const location = useLocation();

    return (
        <Grid centered style={{ marginTop: '3em' }}>
            <Grid.Row centered>
                <Grid.Column width={10}>
                    <Segment placeholder>
                        <Header icon>
                            <Icon name='warning sign' color='red' />
                            Sorry, you are not authorized to access this page.
                        </Header>
                        <Segment.Inline>
                            <Button as={Link} to={`/login?return=${location.pathname + location.search}`} primary>
                                Return to Login
                            </Button>
                        </Segment.Inline>
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}